import type { ReactNode } from "react";
import { Head } from "@landrr/core";
import { Footer, Navbar } from "@landrr/blocks";
import { docNav, footer, siteName } from "../site.config";

interface DocPageProps {
  title: string;
  description: string;
  children: ReactNode;
}

export function DocPage({ title, description, children }: DocPageProps) {
  return (
    <>
      <Head title={title} description={description} ogTitle={title} ogType="article" />
      <div className="min-h-screen flex flex-col">
        <Navbar
          siteName={siteName}
          homeHref="/"
          links={docNav}
          className="sticky top-0 z-50"
        />
        <main className="flex-1 w-full py-12 px-6">
          <article className="mx-auto max-w-3xl space-y-6 text-foreground [&_h1]:text-4xl [&_h1]:font-bold [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:pt-4 [&_p]:text-muted-foreground [&_p]:leading-relaxed [&_code]:rounded [&_code]:bg-muted [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-foreground [&_pre]:rounded-xl [&_pre]:border [&_pre]:border-border [&_pre]:bg-card [&_pre]:p-4 [&_pre]:overflow-x-auto [&_pre]:text-sm [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_ul]:text-muted-foreground">
            {children}
          </article>
        </main>
        <Footer {...footer} />
      </div>
    </>
  );
}
